import './styles/animate.css';
import './styles/introjs.css';
import './styles/main.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import reduxThunk from 'redux-thunk';
import reducers from './reducers';
import App from './components/App';
import {logging} from './middleware/logging';
import config from './config';
import { unregister } from './registerServiceWorker';

const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = config.logging ? [reduxThunk, logging] : [reduxThunk];
  
const store = process.env.NODE_ENV === 'development' 
    ? createStore(reducers, {}, reduxDevTools(applyMiddleware(...middleware)))
    : createStore(reducers, {}, applyMiddleware(...middleware));



ReactDOM.render(
  <Provider store={store}>
    <LocaleProvider locale={enUS}>
      <App />
    </LocaleProvider>
  </Provider>
  , document.getElementById('root')
);


unregister();



// WEBPACK FOOTER //
// ./src/index.js